export const habilidadesDuras = [
 
  {
    habilidad: "JavaScript",
    porcentaje: 85,
  },
  {
    habilidad: "TypeScript",
    porcentaje: 80,
  },
  {
    habilidad: "React",
    porcentaje: 90,
   
  },
  {
    habilidad: "CSS- SASS - Bootstrap -Tailwind CSS" ,
    porcentaje: 90,
   
  },
  {
    habilidad: "Next Js",
    porcentaje: 90,
   
  },
  {
    habilidad: "Express",
    porcentaje: 80,
  },
  {
    habilidad: "MongoDB",
    porcentaje: 80,
  },
  {
    habilidad: "TypeORM",
    porcentaje: 80,
  },
  {
    habilidad: "PostgreSQL",
    porcentaje: 80,
  },
  {
    habilidad: "Firebase",
    porcentaje: 80,
  },
];
export const habilidadesBlandas = [
  {
    habilidad: "Autogestión",
    porcentaje: 90,
  
  },
  {
    habilidad: "Curiosidad",
    porcentaje: 95,
   
  },
  {
    habilidad: "Creatividad",
    porcentaje: 90,
   
  },
  {
    habilidad: "Trabajo en equipo",
    porcentaje: 90,
  },
  {
    habilidad: "Liderazgo",
    porcentaje: 95,
  },
  {
    habilidad: "Comunicación",
    porcentaje: 100,
  },
  {
    habilidad: "Proactividad",
    porcentaje: 99,
  },
];
